import { useState, Dispatch, SetStateAction, FC, useCallback } from 'react'
import { 
  DefaultFormContainer,
  FormItemTitle,
  FormItemSubtitle,
  FormContentContainer
} from './styles'
import StandardInput from '../../basic/StandardInput'
import StandardFormatInput from '../../basic/StandardFormatInput'
import { LeftBar } from '../../basic/LeftBar'
import Button from '../../basic/Button'
import { FirmSectionData } from '../../../dtos/applicationData'
import { validateDateField } from 'src/utils/formDataManipulation'
import { useApplication } from 'src/context/application'
import { useRenewal } from 'src/context/renewal'

interface FirmContactInfoProps {
  setData: Dispatch<SetStateAction<FirmSectionData>>;
  contactData?: {
    phoneNumber?: string;
    website?: string;
    faxNumber?: string;
  }
  isIncorrect?: boolean;
  isWebsiteUrlCorrect? :boolean;
}

const FirmContactInfo: FC<FirmContactInfoProps> = ({ setData, contactData, isIncorrect, isWebsiteUrlCorrect }) => {
  const [addWebsite, setAddWebsite] = useState(() => !!contactData?.website )
  const [addFaxnumber, setAddFaxnumber] = useState(() => !!contactData?.faxNumber)

  const handleChange = (prop: string, value: string) => {
    setData(prev => ({ ...prev, contactInfo: { ...prev.contactInfo, [prop]: value } }))
  }
  
  return (
    <DefaultFormContainer>
      <FormItemTitle>Firm contact info</FormItemTitle>
      <FormItemSubtitle>Please add your firm’s website and fax number if you’d like.</FormItemSubtitle>
      <FormContentContainer>
        <LeftBar />
        <div className='content'>
          <StandardFormatInput
            label="Phone Number"
            maskStyle='phone'
            onValueChange={({ formattedValue }) => handleChange('phoneNumber', formattedValue)}
            value={contactData?.phoneNumber ?? ''}
            isIncorrect={isIncorrect}
            errorMessage={isIncorrect === true ? 'This is a required field' : ''}
            errorCode= 'EC2'
            
          />
          {addWebsite ? (
            <StandardInput
              label="Website"
              onChange={e => handleChange('website', e.target.value)}
              value={contactData?.website ?? ''}
              isIncorrect={isWebsiteUrlCorrect}
              errorMessage={isWebsiteUrlCorrect === true ? 'Enter a valid url' : ''}
              errorCode= 'EC3'
              
            />
          ) : (
            <Button variant='secondary' onClick={() => setAddWebsite(true)} >Add website</Button>
          )}
          {addFaxnumber ? (
            <StandardFormatInput
              label="Fax number"
              maskStyle='phone'
              onValueChange={({ formattedValue }) => handleChange('faxNumber', formattedValue)}
              value={contactData?.faxNumber ?? ''}
            />
          ) : (
            <Button variant='secondary' onClick={() => setAddFaxnumber(true)} >Add fax number</Button>
          )}
        </div>
      </FormContentContainer>
    </DefaultFormContainer>
  )
}

export default FirmContactInfo